import React from 'react'

export default () => <div className='welcome-text'>Get Paid to Explore the World!</div>